import type { SvgIconProps } from './types';

export function GlobalPaymentsLogo(props: SvgIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="155px" height="28px" viewBox="0 0 160 30" {...props}>
                                                <g transform="translate(0, 3)" stroke="#0BA4DB" strokeWidth="2" fill="none">
                                                    <circle cx="11" cy="11" r="10" strokeWidth="2.2" />
                                                    <path d="M11 1a11 11 0 0 1 3.5 10A11 11 0 0 1 11 21" strokeWidth="1.5" />
                                                    <path d="M11 1a11 11 0 0 0-3.5 10A11 11 0 0 0 11 21" strokeWidth="1.5" />
                                                    <path d="M1 11h20" strokeWidth="1.5" />
                                                </g>
                                                <text x="28" y="20" fontSize="14" fontFamily="Arial, sans-serif" fontWeight="700" fill="#0A2540">
                                                    global payments
                                                </text>
                                            </svg>
  );
}
